import { z } from 'zod';

export const StateZod = z.object({
    name: z.string(),
    code: z.string(),
    country: z.string(),
});
export type State = z.infer<typeof StateZod>;

export const CountryZod = z.object({
    code: z.string(),
    name: z.string(),
});

export type Country = z.infer<typeof CountryZod>;

export const ControlsDataZod = z.object({
    document_visibility: z.array(z.string()).optional(),
    relationship_type: z.array(z.string()).optional(),
    states: z.array(StateZod).optional(),
    countries: z.array(CountryZod).optional(),
});
export type ControlsData = z.infer<typeof ControlsDataZod>;
